import { render, staticRenderFns } from "./ForgotForm.vue?vue&type=template&id=e130288c"
import script from "./ForgotForm.vue?vue&type=script&lang=js"
export * from "./ForgotForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports